import { render, staticRenderFns } from "./HealthRecordOverviewDetail.vue?vue&type=template&id=727e8523&scoped=true"
import script from "./HealthRecordOverviewDetail.vue?vue&type=script&lang=js"
export * from "./HealthRecordOverviewDetail.vue?vue&type=script&lang=js"
import style0 from "./HealthRecordOverviewDetail.vue?vue&type=style&index=0&id=727e8523&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727e8523",
  null
  
)

export default component.exports